import React, { Component } from 'react'
import PropTypes from 'prop-types'

const defaultOptions = {
    searchSuggestionCount: 3,
    searchCount: 10,
    searchParams: undefined
}

const calculatePage = (result, searchCount) => {
    if (!result || !result.content || !result.content.metadata || !result.content.metadata.pagination) {
        return 0
    }
    const { start } = result.content.metadata.pagination
    if (!searchCount)
        searchCount = defaultOptions.searchCount
    return Math.floor(start / searchCount)
}

const calculatePageSize = (result, searchCount) => {
    if (!result || !result.content || !result.content.metadata || !result.content.metadata.pagination) {
        return 0
    }
    if (!searchCount)
        searchCount = defaultOptions.searchCount
    return searchCount
}

export default function withReduxConnectedDataTable(ChildComponent, options = {}) {
    const resolvedOptions = Object.assign({}, defaultOptions, options)

    class ReduxDataSourceWrapper extends Component {
        static propTypes = {
            getMetadata: PropTypes.func,
            getMetadataResult: PropTypes.object,
            getSearchSuggestion: PropTypes.func,
            getSearchSuggestionResult: PropTypes.object,
            search: PropTypes.func.isRequired,
            searchResult: PropTypes.object,
        }

        static defaultProps = {
            getMetadata: () => {},
            getSearchSuggestion: () => {},
        }

        constructor(props) {
            super(props)

            this.state = {
                data: [],
                dataPage: 0,
                isDataFetching: false,
                isSearchFetching: false,
                metadata: {},
                pageSize: 0,
                searchSuggestion: [],
                totalItems: 0,
            }

            this.handleSearchTextChange = this.handleSearchTextChange.bind(this)
            this.handleUpdateData = this.handleUpdateData.bind(this)
        }

        componentWillMount() {
            this.props.getMetadata()
        }

        componentWillReceiveProps(nextProps) {
            const {
                getMetadataResult,
                getSearchSuggestionResult,
                searchResult
            } = nextProps

            this.setState({
                data: searchResult && searchResult.success && searchResult.content && !searchResult.isFetching ?
                    searchResult.content.results :
                    [],
                dataPage: calculatePage(searchResult, resolvedOptions.searchCount),
                isDataFetching: searchResult && searchResult.isFetching,
                isSearchFetching: getSearchSuggestionResult && getSearchSuggestionResult.isFetching,
                metadata: getMetadataResult || {},
                pageSize: calculatePageSize(searchResult, resolvedOptions.searchCount),
                searchSuggestion: getSearchSuggestionResult && getSearchSuggestionResult.success && !getSearchSuggestionResult.isFetching ?
                    getSearchSuggestionResult.content.results.map((i) => i.name.value) :
                    [],
                totalItems: searchResult && searchResult.success && searchResult.content ?
                    searchResult.content.metadata.pagination.total :
                    0,
            })
        }

        parseFilterData(filterData) {
            const result = {}

            Object.keys(filterData).forEach((key) => {
                const filter = filterData[key]

                if (Array.isArray(filter)) {
                    result[key] = filter.join(',')
                }
                else if (typeof filter === 'object' ) {
                    const { value } = filter

                    if (value && Array.isArray(value)) {
                        result[key] = `${filter.op}:${value.join(',')}`
                    }
                    else {
                        result[key] = `${filter.op}:${value}`
                    }
                }
                else {
                    result[key] = filter
                }
            })

            return result
        }

        handleUpdateData(childState, childProps) {
            const { pageSize: size } = childProps
            const { page, filterData } = childState
            const { key, value } = childState.sorting[0]

            const params = Object.assign({
                pc: resolvedOptions.searchCount,    // count
                ps: page * size,                    // start
                q: childState.query,
                sd: value > 0 ? 'asc' : 'desc',     // sort direction
                sf: key                             // sort fields
            }, this.parseFilterData(filterData), resolvedOptions.searchParams)

            this.props.search(params)
        }

        handleSearchTextChange(query, childState) {
            if (query) {
                const { filterData } = childState
                const params = Object.assign({
                    pc: resolvedOptions.searchSuggestionCount,
                    q: query
                }, this.parseFilterData(filterData))

                this.props.getSearchSuggestion(params)
            }
            else {
                this.setState({ searchSuggestion: [] })
            }
        }

        render() {
            const {
                data,
                dataPage,
                isDataFetching,
                isSearchFetching,
                metadata,
                pageSize,
                searchSuggestion,
                totalItems
            } = this.state
            const childProps = {
                data,
                dataPage,
                isDataFetching,
                isSearchFetching,
                metadata,
                onSearchTextChange: this.handleSearchTextChange,
                onUpdateData: this.handleUpdateData,
                pageSize,
                searchSuggestion,
                totalItems
            }
            return <ChildComponent {...childProps} />
        }
    }

    return ReduxDataSourceWrapper
}


// WEBPACK FOOTER //
// src/containers/high-order-components/with-redux-connected-data-table.js